module.exports = __webpack_public_path__ + "static/media/-1.644f64c2.svg";